export const MaxFilePathLength =  1024;
export const WarningFilePathLength = 240;
